import React from 'react';
import { Container, ContentContainer } from '../shared/styles';
import Form from './configuration-components/form';
import Actions from './series-components/actions';

export default function Configuration() {
  return (
    <Container>
      <ContentContainer>
        <h1>Series Configuration</h1>
        <Form />
      </ContentContainer>
      <Actions />
    </Container>
  );
}
